import React, { useId } from "react";
import { useNavigate } from "react-router-dom";

import { iconDraft, iconPending, iconCheckOutline, iconItineraryUpdated } from "src/assets/images";

// query
import { updateNotificationStatus } from "src/Query/Dashboard/dashboard.query";

import { ItineraryStatusCodes, selectItineraryStatusOptions } from "src/constants/generics";
import { allRoutes } from "src/constants/AllRoutes";
import "./notification.scss";

const NotificationItem = ({ item, handleClose }: any) => {
  const uniqId = useId();

  const notificationImage = {
    default: {
      src: item?.icon,
      alt: item?.text
    },
    "status-change": {
      src: iconCheckOutline,
      alt: "status-change"
    },
    ["status-change-" + ItineraryStatusCodes.partialPaid]: {
      src: iconPending,
      alt: "status-partialPaid"
    },
    ["status-change-" + ItineraryStatusCodes.fullyPaid]: {
      src: iconPending,
      alt: "status-fullyPaid"
    },
    ["status-change-" + ItineraryStatusCodes.pendingAgentApproval]: {
      src: iconPending,
      alt: "status-pendingAgentApproval"
    },
    ["status-change-" + ItineraryStatusCodes.draft]: {
      src: iconDraft,
      alt: "status-draft"
    },
    ["status-change-" + ItineraryStatusCodes.confirmed]: {
      src: iconCheckOutline,
      alt: "status-confirmed"
    },
    ["status-change-" + ItineraryStatusCodes.completeWithAves]: {
      src: iconCheckOutline,
      alt: "status-completeWithAves"
    },
    "itinerary-update": {
      src: iconPending,
      alt: "itinerary-update"
    },
    thread: {
      src: iconItineraryUpdated,
      alt: "thread"
    },
    chat: {
      src: iconItineraryUpdated,
      alt: "chat"
    }
  };

  const navigate = useNavigate();

  const handleClickNotification = async () => {
    await updateNotificationStatus({
      notificationId: item?.id
    });

    if (item?.type?.substr(0, 13) === "status-change") {
      navigate(allRoutes.itinerary);
      handleClose();
    } else if (item?.type === "itinerary-update") {
      navigate(`${allRoutes.itinerary}/${item?.referenceId + allRoutes.edit}`);
      handleClose();
    } else if (item?.type === "chat") {
      if (item?.redirectionParams?.supplierId) {
        navigate(
          `${allRoutes.itinerary}/${item?.referenceId + allRoutes.itineraryAddServiceSchedule}?supplierId=${item?.redirectionParams?.supplierId}`
        );
      } else if (item?.redirectionParams?.hotelRefId) {
        navigate(
          `${allRoutes.itinerary}/${item?.referenceId + allRoutes.itineraryAddServiceSchedule}?hotelRefId=${
            item?.redirectionParams?.hotelRefId
          }&dayIndex=${item?.redirectionParams?.dayIndex}&eventIndex=${item?.redirectionParams?.eventIndex}&eventId=${
            item?.redirectionParams?.eventId
          }`
        );
      }
      handleClose();
    } else if (item?.type === "thread") {
      navigate(`${allRoutes.messageThread}?threadId=${item?.referenceId}`);
      handleClose();
    }
  };

  function notificationText() {
    if (item?.type?.substr(0, 13) === "status-change") {
      const textArray = item?.text?.split(" ");
      const lastWord = textArray.pop();
      const updatedText = textArray.join(" ") + " " + selectItineraryStatusOptions?.find((i) => i?.value === lastWord)?.label;
      return updatedText;
    } else {
      return item?.text;
    }
  }

  return (
    <div className={`notification-item ${item.type}`} onClick={handleClickNotification}>
      <input
        className="notification-checkbox"
        type="checkbox"
        id={`${item?.type}-${uniqId}`}
        value={`${item?.type}-${uniqId}`}
        checked={!item?.isRead}
      />
      <div className="notification-item-content">
        <div className="notification-item-icon">
          <img
            src={notificationImage[item?.type]?.src || notificationImage.default.src}
            alt={notificationImage[item?.type]?.alt || notificationImage.default.alt}
          />
        </div>
        <h3 className="notification-item-title">{notificationText()}</h3>
      </div>
    </div>
  );
};

export default NotificationItem;
